export interface SandboxAdvertisementSeed {
  title: string;
  description: string;
  images: string[];
}

// С продакшена перенесены только публичные картинки и тексты карточек.
// Авторы, контакты, клубы, цены и служебные поля создаются отдельно в resolver.
export const sandboxAdvertisementSeeds: readonly SandboxAdvertisementSeed[] = [
  {
    title: 'SIM RACING',
    description:
      "Кок пит заказной черно-красный, монитор MSI 34'', MOZA R5, сиквенталка MOZA, ручник MOZA, доп.дисплэй MOZA, полуковш эко кожа, системник (i5, MSI RTX 4060Ti, ddr5 16g, ssd M2 1Tb, ssd 1Tb) Цена с системником 300.000",
    images: [
      'https://storage.yandexcloud.net/smartshell-static/1630/3yN6Bta60NMkyzxtvhlk46iencypcwrcs59nejvduz8cilxie65xa1cbond-9k8c1bmocss7milgus0qs3muedeqrvyrdjjj_yu3--mcwwuy8ww_diec5ejkgzbr.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1630/L5OX2WftFbHLf3tpwmiwr4yecfgk1aaharwzfbjikmgf_yxanuk8k6w-fv8cbrwvafl6a_aqzxtcehkdqksuekhekpkzwoyttdg0pfuo56ibzajuk8ui1fduu0ar.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1630/2DxeJF1T2Cxjginbzietkydhx7jcfeo4vs0kqxz-mp8tcntg6clngvyd05_sqqsmokglsm-jj3mb6g7drq3xk0tqbmebxtzg5x_rsvlhapkovuuuzt8dy8xslssk.jpg',
    ],
  },
  {
    title: 'Коммутатор HPE OfficeConnect 1920S 48G 4SFP (JL382A)',
    description:
      'Управляемый коммутатор уровня 3 (Layer 3)\nФорм-фактор: 19U\nПорты: 48 × RJ-45 (10/100/1000 Мбит/с, автоопределение скорости) + 4 × SFP (100/1000 Мбит/с)\nВнутренняя пропускная способность: 104 Гбит/с\nСостояние хорошее, был в работе 7 лет без нареканий.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/1702/YJyZuRzIrFV7svtf03enaj3v0o6j5mhjcbta1.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1702/tsYf1rYaDLPJdvlrowpmx0afd3pcxqdgmgw82.jpg',
    ],
  },
  {
    title: 'Компьютерный стол',
    description: 'Столы из ОСБ',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3053/behTxNLyuodw2jjwdoztcinl24jxwyilhkxeec7tpkp7v0aj4unyla9pge0lo5aqvnhhvkciob_vh2g0iw5cn1l_gwxbe4sgprcscwajag2wsrzneihvpbyerbxg.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/W5bTDfYiSLHOgw7drtepbddt5escuvoouumlvva0egm6g5jim7couad_an69gppfgghkoiqqn7yop3y1thh3dukjij0xprwghqdxalyviaz1ibnjnbq96h8zf0ds.jpg',
    ],
  },
  {
    title: 'Монитор Samsung 24 дюйма 240гц',
    description:
      'Модель: Odyssey G4 S25BG400EI\nМониторы в отличном состоянии.любые проверки.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3053/rybGpldgRJPurcxrwmuxzuvyqmqcytu1vl3cvva0egm6g5jim7couad_an69gppfgghkoiqqn7yop3y1thh3dukjij0xprwghqdxalyviaz1ibnjnbq96h8zf0ds.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/rDK0y9PoUu0D2xisnouvexixjgk1lyol8legzrsctccmo-xuazlqynyt-ovlfofg72-jmey0ffhhz-jxbigxb1cq1ichzbfdta2iripgtnsflqrqi82tpdhejbdd.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/cwlJjHniLVAOaobhuxwsreuh2sd23tse6oxnmisl3rvhwhlbwovymfjdzrcwfvnblpkadjok19c7ctrgpaptdwakqzvjoueictil-vuonlarwu90k9atgydkyhsc.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/LmNdUssZpbD060ngplgp7eryl5pwtmcwfnp7ue3declfuuiaxxrqepfzgmdcaj0nat88qgr9zkbojfi5nclybkg8uwoqi_vfs3goxxrs9lgezray567raa_lbhyc.jpg',
    ],
  },
  {
    title: 'Комплект 12400f + 3070ti + 16gb ddr4',
    description:
      'Продам комплект:\nматеринская плата asus b660m-k + i5 12400 + rtx 3070ti + 16gb ddr 4 + кулер JonSBO 1000.\n\nДля полного комплекта вам останется докупить системный блок, блок питания и ssd.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3233/fvGNXvZlxEqZsvpaqpumqpuf9ke2qqlx79gmimg_2812.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3233/DijdKL24rpV2lqr0py6v4rzjzdpiwsk5kxykimg_2814.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3233/8E8XS2EUiA2Fmbzsd5qld3aztrwqo5nr03vfimg_2813.jpeg',
    ],
  },
  {
    title: '12400f + MSI PRO B760M-P DDR5 + кулер',
    description:
      'Продам в сборе 12400f + мать msi pro b760m-p ddr5 + охлаждение.\nИдеальное состояние.\nВ наличии 5 комплектов.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3233/2H6ytO3kAGvrkor6x5sryzmd4j509h5d4kniimg_2464.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3233/E4EJCBMdgUViqo0up5reuybt3hfi6mplix0timg_2463.jpeg',
    ],
  },
  {
    title: 'УПРАВЛЯЮЩИЙ В КЛУБ СПБ',
    description:
      'Опыт работы 3.5 года, в управлении 1 клуб , хочу взять в работу еще. Звоните обсудим\n\n-Управление персоналом: подбор, обучение, составление графиков работы и контроль администраторов.\n\n-Контроль финансов: ведение кассовой отчетности, инкассация и учет доходов клуба.\n\n-Работа с клиентами: решение конфликтных ситуаций и поддержание высокого уровня сервиса.\n\n-Развитие клуба: создание акций, проведение турниров и привлечение новых посетителей.\n\n-Технический надзор: контроль исправности компьютеров, девайсов и работы интернета совместно с системным администратором.\n\n-Хозяйственная деятельность: закупка расходных материалов, напитков, снеков и контроль чистоты в залах.\n\n-Взаимодействие с госорганами: подготовка документов и соблюдение правил пожарной безопасности и охраны труда.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/2803/QEtQGExMnNJsyztp9huocuct4q65mmrd8foi1111.jpg',
    ],
  },
  {
    title: 'Комплект i5 12400F + MSI B760M-E DDR4 + Кулер | 5 Шт.',
    description:
      'Готовый, полностью обслуженный игровой комплект (связка) на сокете LGA1700.\n\nЖелезо стояло в нашем компьютерном клубе, отработало ровно 1.5 года. Обслуживалось строго по регламенту. Нагрузок выше нормы платы не видели.\n\nЧто входит в комплект:\n\nПроцессор: Intel Core i5-12400F (LGA1700, 6 ядер / 12 потоков).\n\nМатеринская плата: MSI PRO B760M-E DDR4.\n\nКулер: Башенный кулер ID-Cooling SE-903-SDv3',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/5274/1q25pTVI6pW6j8wfjdwlfw15pj5ctqvxbxh0411.jpg',
      'https://storage.yandexcloud.net/smartshell-static/5274/E32VQh0wxNB9hleibo3yogrpcyiidnxbr7io512.jpg',
    ],
  },
  {
    title: 'Компьютерный клуб доход 100к',
    description:
      'Продаётся компьютерный клуб в топовой локации Москвы\n\n📍 Метро 5 мин, школа рядом, конкурентов нет\n🎁 Большая площадь помещения 150м\n💰 Чистая прибыль: 100–150 тыс. ₽/мес\n🖥️ 22 ПК (17 общий зал 1660TI + 5 VIP на 3070) + PS5\n🌐 NAS UGREEN + MikroTik + видеонаблюдение\n✅ Ремонт в рабочих зонах сделан\n🚀 Есть место под расширение (2 PS5 / 2 VIP-комнаты)\n\nторг при осмотре',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/1769/WSW9Pv801fxjwwgaoji562gt0th16hmxfqjdxxxl.jpg',
    ],
  },
  {
    title: 'Дизаин+Маркетинг',
    description:
      'Занимаюсь упаковкой и продвижением компьютерных клубов: ВК+Instagram+Телеграмм 🎮\n\nЧто входит:\n— оформление группы ВК,Телеграмм, Инстаграмм\n— обложки, посты, акции, тарифы\n— тексты, фото, описание, работа с отзывами\n— анализ статистики SmartShell\n— идеи акций, креативов и постов под вашу аудиторию\n— визуал, который помогает клубу выглядеть сильнее конкурентов\n\nРаботаю именно с компьютерными клубами, поэтому понимаю нишу, ночные пакеты, VIP-зоны, просадки по будням и локальную конкуренцию.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/6781/Wz1Zoi3bV6BGc3bg9oruddyzoaafjsalbq74nano-banana_20260505_075444_fe5bc0c4.jpg',
    ],
  },
  {
    title: 'Игровое кресло VMMGAME THRONE (Российское производство).',
    description:
      'Доброго дня!Предлагаем компьютерным клубам и игровым залам ограниченную партию игровых кресел VMMGAME THRONE российского производства.\nМы сами используем кресла этого бренда в своих залах и знаем их в ежедневной эксплуатации. Кресла выглядят достойно, выдерживают активную нагрузку и получают положительные отзывы от гостей клуба. Кресла все НОВЫЕ, в коробках. \n\nВ наличии около 90 кресел в трех модификациях:\nTHRONE BLACK (кол-во уточнять на складе, меняется  ежедневно).\nTHRONE VELOUR BLACK.(кол-во уточнять на складе, меняется  ежедневно).\nTHRONE VELOUR GRAY.(кол-во уточнять на складе, меняется  ежедневно).\n\nTHRONE - это удобные игровые кресла с высокой спинкой, боковой поддержкой, подушками под шею и поясницу, мягкими подлокотниками, регулировкой высоты, наклоном спинки до 150° и выдвижной подставкой для ног.\nОтлично подойдут для основных залов, VIP-зон, стримерских комнат и отдельных кабинок.\nВ своих клубах используем следующие модели кресел этого завода: MAROON,ASTRAL, THRONE.\nПредлагаем специальные условия, так как закрываем направление кресел и распродаем текущую партию. При покупке более 20 кресел готов предложить доп.скидку. В пределах Чувашии поможем с доставкой.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/1659/QvDvlJQTQQ3W7fmpgtp1aq8fjpt0qebaur45photo_2026-05-13_17-53-36_%284%29.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1659/TI8YBS4Vb59Wfaatbxhgkzf33ully0jxvqgnphoto_2026-05-13_17-53-36_%282%29.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1659/SDtXQVpQLqLlrunfovgtpsfx8pkeq7ihhypyphoto_2026-05-13_17-53-36_%283%29.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1659/fsaV5DeliZ0Yfegorcjkyrav8cnm6aap9tdxphoto_2026-05-13_17-53-36_%284%29.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1659/yRghySV4Kr9zljuvkproadnrukwtqcyftaufphoto_2026-05-13_17-53-36_%285%29.jpg',
    ],
  },
  {
    title: 'Дизайн обложек для игр',
    description:
      'Разработаю обложки в Вашем фирменном стиле. \nОбложки это те самые картинки, которые у вас отображаются в шелле для гостей, когда они выбирают игру. \n1 шт - 200р\n5 шт - 750р\n15 шт и более - 100р за шт',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9131/Ym70N46kkdumtc82g0wyjpdvzpdy3mwpe2nnleague_of_lg.png',
      'https://storage.yandexcloud.net/smartshell-static/9131/c3ucvqazYBnJsve5gbbaatn5ccxizyjmyek1compressed_009b955a-1dd9-41f5-a8db-6eb6933e4867_1.png',
    ],
  },
  {
    title: 'Монитор Redmi G24 165Hz',
    description:
      'Состояние отличное ( сзади на корпусе следы от герметика, на который крепились кронштейны). Полный комплект. В наличии 20шт.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/6755/1aQrS3sbphbyxe8amkgjui9bw2h2yanprxo102115f3e-4ecb-4b3e-9a1f-6f20bd03de12-cover.jpg',
      'https://storage.yandexcloud.net/smartshell-static/6755/7f7CrZApPyNintlqdedird2c2mygppadaihxlcelbu-rnsb55f3rumv7es1qvdxoxgnj6d2hebz1p8cwmg7jardgeezc05fbmz0k0o0bqsyujpmiqzghh_r7q49h.jpg',
      'https://storage.yandexcloud.net/smartshell-static/6755/3GLuK3wILtKKbp5u31bsfnv0kkvvnt9dgsk6t9i-a8n9ssxrcw_modzm0tg0g95czblxzmubvyg1g2q5ovlpsaerpyizsvgwbo4bojnyvvjrqxn63worwsc06_rb.jpg',
      'https://storage.yandexcloud.net/smartshell-static/6755/NO0gVd5CbGtsg8twqmafkod9ibohjoo6qzbeus-f1me-x09ibqla5yur4i-rj9rzr4kkp8vzzvrzeja-yxbc-dpyrdqqlvagqnr29pfjuvqyhosj2t0zwluhjq5f.jpg',
    ],
  },
  {
    title: 'Графический дизайн',
    description:
      'Дизайн для ПК-клубов от человека, который работает в этой индустрии. Я знаю, что нужно клубам не только как дизайнер, но и как сотрудник управления. Создаю современный дизайн по доступным ценам: прайсы, баннеры, оформление соцсетей и многое другое',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9112/SGZ6OjV6vQUqmyi3ahqwmwodjwvq9s9fmtz9price-list_pc_clubs.png',
    ],
  },
  {
    title: 'Динамический прайс для второго монитора',
    description:
      'Интегрирую ваш текущий прайс лист в динамический, тарифы на втором мониторе будут отображаться в соответствии со временем суток и днём недели.\n\nСрок выполнения работы до 2 дней.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9293/Yc2hWKhQVUe5yopazfkjsobuejurxf5arop6chatgpt_image_3_%D0%B8%D1%8E%D0%BB._2026_%D0%B3.%2C_04_19_48.png',
    ],
  },
  {
    title: 'Стикерпак для телеграмм',
    description:
      'Создание стикерпака для вашего киберклуба.\nВ пакет за 1000р входит 15 стикеров с любыми эмоциями или надписями.\n\nЕсли необходимо меньшее количество стикеров, то рассчет идёт по стоимости 100р за 1 стикер.\n\nСрок выполнения работы до 7 дней.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9293/p2lLPBIxpiWtejvfxxsgg05llmplczblzbnx89102ab3-b805-4bb7-bc65-70e02677afd6.png',
    ],
  },
  {
    title: 'Оформление шелл',
    description:
      'В пакет входит:\nОформление аватарки администратора;\nОформление других аватарок для групп/чатов/ботов/соц сетей;\nОформление рабочего стола клиентского шелл;\nОформление заставки для пк в простое (статичная/анимированная).\n\nСрок выполнения работы до 7 дней с момента оплаты.\n\nПри выборе пакета с анимированными заставками + 1000р.\n\nОформление иконок для игр и приложений + 1000р за 20 шт.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9293/U2T71yfx7Jbkzyig0miw81nd084qblpcm6lechatgpt_image_3_%D0%B8%D1%8E%D0%BB._2026_%D0%B3.%2C_04_01_11.png',
    ],
  },
  {
    title: 'Оформление иконок',
    description:
      'До 20 персонализированных иконок для ваших игр в едином стиле, подходящем под атмосферу и оформление вашего клуба.\n\nСрок выполнения работы до 2 дней с момента оплаты.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9293/YrtyGfiLjcwHyps1ghzr6gkem0jnlq4q5sopchatgpt_image_30_%D0%B8%D1%8E%D0%BD._2026_%D0%B3.%2C_1_%281%29.png',
      'https://storage.yandexcloud.net/smartshell-static/9293/wAe7Of8Fid5pixf5rpuped4558p1xaqlz0qnqwdghnkollmyveegx5s0sd5nvhtvx1mvun47%D1%81%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA_%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0_2026-06-6666.png',
      'https://storage.yandexcloud.net/smartshell-static/9293/rlHNmhMRSQLs6ntkbmvmtptwehnvlnqqavkrchatgpt_image_30_%D0%B8%D1%8E%D0%BD._2026_%D0%B3.%2C_1.png',
      'https://storage.yandexcloud.net/smartshell-static/9293/TAmdHqtFFRXlnvzhkkiq69eq0saz7rjhpic4qwdghnkollmyveegx5s0sd5nvhtvx1mvun47%D1%81%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA_%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0_2026-06-26_033610.png',
    ],
  },
  {
    title: 'ПОСТЫ/СЛАЙДЫ ДЛЯ ОБЪЯВЛЕНИЙ И АКЦИЙ',
    description:
      'Оформление картинки для постов или акционных слайдов на телевизор под заказ. Работаем с любым размером экранов и телевизоров. \nЦена указана за ед. шт. \nСкидка за первое обращение (10% от стоимости заказа)',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/5847/tkUXx3zc12nzi9s8nx7nnk1vbcpjuwnmdcmm213321.jpg',
      'https://storage.yandexcloud.net/smartshell-static/5847/h8CSNDZ59CkQ5lh4hxyt8rknpr4ddoko6c0y1.png',
      'https://storage.yandexcloud.net/smartshell-static/5847/S96VinOz3Un5cujaboq6xbralwlw3jbhvokb2.png',
    ],
  },
  {
    title: 'ФОНЫ ДЛЯ SMART SHELL',
    description:
      'Фоны для SMART SHELL (режим сна и не только) под заказ. Работаем с любым размером экранов и телевизоров. \nЦена указана за ед. шт. \nСкидка за первое обращение (10% от стоимости заказа)',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/5847/tX7Gi12ExxHzkskk8wjfbso0dyfpyfadmzsb%D0%BF%D1%80%D0%B0%D0%B9%D1%81%D1%8B_%281%29.png',
      'https://storage.yandexcloud.net/smartshell-static/5847/Y3ZImQSVcmASk5epimmowv0onnv4zprgmgx09205d229-253f-403c-abfe-8b36b49dff46.jpg',
      'https://storage.yandexcloud.net/smartshell-static/5847/1NnNbwmiILuzit66gostr5kjsj6loqhhyz7rc52d7b5b-54dc-41ae-8667-6b955f6ef9e2.jpg',
      'https://storage.yandexcloud.net/smartshell-static/5847/cT1tipgkGFv8hqspc3xo048r6tnjanspnral08a95b95-86d4-486d-8f5c-d26d9a1f05e3.jpg',
      'https://storage.yandexcloud.net/smartshell-static/5847/nYLNpnHrmKH1egpznpl7ipvbaz48vfw69o7w940ce525-c88f-42f5-81f8-eba3418255ca.jpg',
    ],
  },
  {
    title: 'Сайт компьютерного клуба под ключ (не конструктор)',
    description:
      'Покупка сайта — это не расход. Это инвестиция.\nМы создадим для Вас не просто красивый, а продающий сайт, которые не только окупится, он будет зарабатывать. Делаем полностью кастомные сайты на чистом коде, никаких конструкторов и шаблонов, полная свобода самовыражения.\nПортфолио покажем по запросу.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/4978/Du1fyO90rjrJjg7yfxlplqjwo0yuvxbo48tgchatgpt_image_29_%D0%B8%D1%8E%D0%BD._2026_%D0%B3.%2C_21_06_17.png',
    ],
  },
  {
    title: 'КАРТОЧКИ ДЛЯ ИГР В SMART SHELL',
    description:
      'Карточки для игр под заказ. Есть возможность заказать БЕСПЛАТНЫЙ пробный шаблон для "примерки" карточек. Работаем с любым объемом. \nЦена указана за ед. шт. \nСкидка за первое обращение (10% от стоимости заказа)',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/5847/RcjV4c4b0reNoy2bazzczifxdaw5sg6zpzcn%D0%BA%D0%B0%D1%80%D1%82%D0%BE%D1%87%D0%BA%D0%B8.png',
    ],
  },
  {
    title: 'ИГРОВОЙ ПК i5-10400F , RTX-2060 SUPER , DDR4-16G',
    description:
      'ИГРОВОЙ ПК i5-10400F , RTX-2060 SUPER , DDR4-16G , SSD SATA 2.5 - 256G , HDD - 1T\nпк в хорошем состоянии',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/8666/eBqGgv3MGvZYwsqm9e6w2jo8fihz5yqifof32026-06-07_18-14-02.png',
      'https://storage.yandexcloud.net/smartshell-static/8666/qDedr6ErQ2INqek0akjzwfqhrc1uhev2jnd22026-06-07_18-15-00.png',
    ],
  },
  {
    title: 'Продам процессоры i3 12100f',
    description:
      'В наличии 5 ш, сняты с компьютеров. Все исправны и рабочие.Цена ЗА 1 ШТ',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3192/grpq5IJ8FkQeffppofrfdv7ub2ilje0ht4s1img_3638.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3192/WLCaqk4I6UCncjnbmlua7mbyzfzmyh2g2zkdimg_3637.jpeg',
    ],
  },
  {
    title: 'ПРАЙС-ЛИСТЫ НА ЛЮБЫЕ ЭКРАНЫ',
    description:
      'Прайс-листы под заказ. Работаем с любым размером экранов и телевизоров. \nЦена указана за ед. шт. \nСкидка за первое обращение (10% от стоимости заказа)',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/5847/uGsUQJnXRjzdizd8gjurfjkozyxjuusfc4pc%D0%BF%D1%80%D0%B0%D0%B9%D1%81%D1%8B.png',
    ],
  },
  {
    title: 'Видеокарта 3070',
    description:
      'Состояние: Б/у\nБренд: GIGABYTE\nМодель: AORUS GeForce RTX 3070 MASTER 8G\nКод производителя: GV-N3070AORUS M-8GD rev. 1.0/1.1\nОписание\nРабочие видеокарты',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3053/4moPgt0ydGL0mfpjvdx9drezpbv0xifcezht2ptaof-mqzfc3kybtxeap4d8nszjllmzhjcidek2h7a3o5gwq8wkyfuii5mg9o53exb1uwuezi0twotqm32yaey4.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/2TYI8PNaDj48lxyi6ua7oq1suej95i84tnmxds2ec0enjthgjcjzsinwkz9m8k_7dej-bvpfbworz4apnuld9njwkdzrxqs2efuabvshtzvjr82kq6vwgtxeftxu.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/UtllrHHVMxGDigxz08k9fdqvkpvanp3dsvwgmoqc8revrllvshus6y_za1ls1m6wv0ib3vy7mw-vmeu7k4gkgrdyqjlf1w1vvl7xead8qvkgj7jgsvtml1ymhksa.jpg',
      'https://storage.yandexcloud.net/smartshell-static/3053/lNLaTGyle9Bwrtljpzataofjrvy6ro0d9gedwkyoh9q70psnga8rpltlyrbw_auxnhzgngaep6vt2rr10ndfydcjzqdvy34jqvys5hxn9xr4-ctnycnxh-3knoe4.jpg',
    ],
  },
  {
    title: 'Мониторы Philips 27 240гц FHD',
    description:
      'Продам мониторы в отличном состоянии.\n3 шт\nPhilips 27M1N5200PA',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3233/Wuo7EvZhw2B170ljav1qxqu8fozvy7pbkhxeimg_2468.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3233/vCcs47YFUEhmulom91rjepac2foa9vubndynimg_2467.jpeg',
    ],
  },
  {
    title: 'Мониторы LG UltraGear 27 240гц FHD',
    description:
      'Продам 5 мониторов LG UltraGear 27GP750-B 240гц FHD.\nИдеальное состояние, без битых пикселей и так далее.',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/3233/OHxX1CTkLEg9ehdf93rtf1v7smordaubg9yoimg_2465.jpeg',
      'https://storage.yandexcloud.net/smartshell-static/3233/J4Lj86Rdaanrvurw3lfjicl9kvpv06oha983img_2466.jpeg',
    ],
  },
  {
    title: 'BenQ XL2546-B; 5шт.',
    description:
      'Продам 5 мониторов BenQ XL2546-B.\n\n• Диагональ 24”\n• Частота обновления 240 Гц\n• Хорошее состояние\n• Полный комплект, включая оригинальные коробки',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/1649/UPtDRERoUS8B3yj4vynvkujr5zdiocnanoccphoto_1_2026-06-12_12-40-44.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1649/vBnjOD9x6ABO8whef10q6tfmflb4ttrpfijsphoto_5_2026-06-12_12-40-44.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1649/AxFbPaG37xcoocdg2je363aflucezkmrekxvphoto_4_2026-06-12_12-40-44.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1649/KvRROfYViIdvdu7u0bmpjy0fgzhczvyunqm9photo_3_2026-06-12_12-40-44.jpg',
      'https://storage.yandexcloud.net/smartshell-static/1649/cqCvZGZ3b35us6vgd1f2kthvb6kdzlelbyohphoto_2_2026-06-12_12-40-44.jpg',
    ],
  },
  {
    title: '3д печать надписей и переферии',
    description:
      'Печатаю на заказ надписи, таблички и детали любой сложности\nЦена зависит от сложности. В объявлении начальная цена',
    images: [
      'https://storage.yandexcloud.net/smartshell-static/9875/dodU0g1XDC3dbkic2zxzcjkeksx1paw84glhn4indzkhycdlxl3_yrdrsh93ptggbcjdeokmgtnolzph6xjg4mpxwdn0flouteohfa-5rqdwk4b-5ryxon9-oh5k.jpg',
      'https://storage.yandexcloud.net/smartshell-static/9875/HmOMLsLjkSYjez8l1zcnt7pg6eestmi8xj9pzhzbnpord6igyxfgj1j_3l-5vpad6id9o7fyunscbezhpubgsqjycgvucixpy7qoxiptmr0czk9zz17ltfi9-58n.jpg',
      'https://storage.yandexcloud.net/smartshell-static/9875/LUWGfHrkI5XNzckntpmxkrms0uxrklussjqyiyu-pxu8rqpbbj1g-g8qkunohvidfgwkw-nh5beh_dd1ru1w2jbuyrfgzueb48ibtfd0plwm6pxvew5tuha3w3f5.jpg',
      'https://storage.yandexcloud.net/smartshell-static/9875/dlw7ypiTTEYPad4icrkszmmodc2zbaosvpz5mooejio5ffkf1eygrfofwhcpyenxiobrykborosftikui3juujiw-gfkp_ljkabzvnevoaygqub7axsegp1j_ame.jpg',
      'https://storage.yandexcloud.net/smartshell-static/9875/wg4rUvWpB7GPmm0hlqzebh4d0tdevx3gvqad0zs4y23ptkfecuvod9p6egbpbggskdmguzexrdc1p9jw-fybu1ygnpxotqu8ct36zusfajsrv4h0o3l2yrm1dcx6.jpg',
    ],
  },
];
